import { Auth } from './types';
export default {
  isAuthenticated: (state: Auth) => !!state.accessToken,
  authStatus: (state: Auth) => state.status,
  isError: (state: Auth) => (state.status === 'error'),
  requestingAuth: (state: Auth) => (state.status === 'loading'),
};
